export const adapt24hoursTimeTo12hoursTime = (time24hours: string): string => {
  const timeParts = time24hours.match(/(\d{1,2}):(\d{2})/);

  if (!timeParts) {
    return '';
  }

  let hours = parseInt(timeParts[1], 10);
  const minutes = timeParts[2];

  const period = hours >= 12 ? 'PM' : 'AM';

  if (hours === 0) {
    hours = 12;
  } else if (hours > 12) {
    hours -= 12;
  }

  return `${hours.toString().padStart(2, '0')}:${minutes} ${period}`;
};
